import React from 'react'
import { Link } from 'gatsby'
import './Header.css'

class Header extends React.Component {
  constructor(props) {
    super(props)

    this.state = {
      hasScrolled: false,
    }
  }

  componentDidMount() {
    window.addEventListener('scroll', this.handleScroll)
  }

  handleScroll = event => {
    const scrollTop = window.pageYOffset

    if (scrollTop > 50) {
      this.setState({ hasScrolled: true })
    } else {
      this.setState({ hasScrolled: false })
    }
  }

  render() {
    return (
      <div
        className={this.state.hasScrolled ? 'Header HeaderScrolled' : 'Header'}
      >
        <div className="HeaderGroup">
          <Link to="/">
            <img src={require('../images/logo.svg')} width="30" alt="aj" />
          </Link>
          <Link to="/Courses" className="Btm_Line">
            Courses
          </Link>
          <Link to="/Downloads" className="Btm_Line">
            Downloads
          </Link>
          <Link to="/Workshops" className="Btm_Line">
            Workshops
          </Link>
          <Link to="Contact" className="Btm_Line">
            Contact
          </Link>
        </div>
      </div>
    )
  }
}

export default Header
